<template>
  <div class="login-main" :class="bgStatus ? 'login-bg' : ''">
    <!-- 头部 -->
    <div class="login-header">
      <div class="lh-left">
        <img src="../assets/img/hmc_logo.png" />
        宏脉软件
      </div>
      <div class="lh-right">
        <span>客莱宝SCRM</span>
        <div class="lhr-centen">
          <p><img src="../assets/img/qiye_logo.png" /></p>
          <span>企业微信服务商</span>
        </div>
      </div>
      <div class="lh-cut" style="display:none;">
        <i
          :class="bgStatus ? '' : 'lh-cut-active'"
          @click="clickGround(false)"
        ></i>
        <i
          :class="bgStatus ? 'lh-cut-active' : ''"
          style="background: #062247"
          @click="clickGround(true)"
        ></i>
      </div>
    </div>
    <!-- 登录 -->
    <div class="login-centen">
      <div class="login-left">
        <img src="../assets/img/group_bail.png" alt="客莱宝" />
      </div>
      <div class="login-box">
        <!-- <div class="lb-weicome" :style="switchover ? 'margin-top:45px' : ''">
          欢迎来到
        </div>
        <div class="lb-title">宏脉 客莱宝</div>
        <div class="lb-form" v-if="switchover">
          <el-form :model="ruleForm" ref="ruleForm">
            <el-form-item
              label="账号"
              prop="account"
              :class="
                ruleAccount ? 'rule-account' : fouceAccount ? 'fouce-input' : ''
              "
            >
              <el-input
                v-model="ruleForm.account"
                autocomplete="off"
                maxlength="11"
                oninput="value=value.replace(/[^\d]/g,'')"
                placeholder="输入您的手机号码"
                @blur="blurAccount"
                @focus="focusAccount('账号')"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="密码"
              prop="pass"
              class="password"
              :class="
                rulePassword
                  ? 'rule-password'
                  : foucePassword
                  ? 'fouce-input'
                  : ''
              "
            >
              <el-input
                v-model="ruleForm.password"
                autocomplete="off"
                placeholder="输入您的密码"
                @blur="foucePassword = false"
                @focus="focusAccount('密码')"
                show-password
                @keyup.enter.native="submitForm('ruleForm')"
              ></el-input>
            </el-form-item>
            <el-form-item
              class="rule-message"
              v-if="rulePassword || ruleAccount"
            >
              <i class="css-icon icon-info"></i><span>{{ ruleTitle }}</span>
            </el-form-item>
            <el-form-item :class="ruleLogin ? 'rule-login' : ''">
              <el-button
                type="primary"
                @click="submitForm('ruleForm')"
                :disabled="ruleLogin"
                >登录</el-button
              >
            </el-form-item>
            <div class="lb-footer">还没有账号？<span>免费注册</span></div>
          </el-form>
        </div>
        <div class="login-code" v-else>
          <div
            class="lc-code"
            @click="clickTap"
            id="wx_qrcode"
            title="点击扫码登录"
          >
            <img src="../assets/img/icon-wechat.png" />
            <span>微信扫码登录</span>
          </div>
          <div class="lc-footer">请点击企业微信扫描二维码登录</div>
        </div> -->
      </div>
    </div>

    <!-- 页脚 -->
    <!-- <div class="login-footer">
      <div class="lf-top">
        <ul style="display:none">
          <li>关于我们</li>
          <li>廉政举报</li>
          <li>联系我们</li>
          <li>加入宏脉</li>
          <li>法律声明及隐私权政策</li>
        </ul>
        <div class="lf-copyright">
          <div>
            <span>© 2002-2021 宏脉信息技术（广州）股份有限公司  版权所有</span>
            <span style="margin-left: 20px;text-decoration: underline;cursor: pointer;" @click="toPolice">粤ICP证：11080780号</span>
          </div>
        </div>
      </div>
      <div class="lf-top">
        <ul style="display:none">
          <li>宏脉集团</li>
          <li>宏脉院务系统</li>
          <li>宏脉医生App</li>
          <li>宏脉微信商城</li>
        </ul>
        <div class="lf-copyright">
          <div style="display: flex;">
            <img src="../assets/img/police.png" style="width: 17px;height: 19px;margin-right: 10px;">
            <span class="lf-span" style="cursor: pointer;" @click="toPolice">广公网安备 44011302001028号</span>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 第二版 先把广公网安备放到上面一行 -->
    <div class="login-footer">
      <div class="lf-top" style="padding-bottom:5px;border: none;">
        <ul style="display:none">
          <li>关于我们</li>
          <li>廉政举报</li>
          <li>联系我们</li>
          <li>加入宏脉</li>
          <li>法律声明及隐私权政策</li>
        </ul>
        <div class="lf-copyright" style="justify-content: center;">
          <div>
            <span
              >© 2002-{{ nowDate }} 宏脉信息技术（广州）股份有限公司
              版权所有</span
            >
            <span style="margin-left: 20px;cursor: pointer;" @click="toPolice"
              >粤ICP证：11080780号</span
            >
            <img
              src="../assets/img/police.png"
              style="margin-left: 20px;width: 17px;height: 19px;margin-right: 10px;transform: translate(0, 5px);"
            />
            <span class="lf-span" style="cursor: pointer;" @click="toPolice"
              >广公网安备 44011302001028号</span
            >
          </div>
        </div>
      </div>
      <div class="lf-top">
        <ul style="display:none">
          <li>宏脉集团</li>
          <li>宏脉院务系统</li>
          <li>宏脉医生App</li>
          <li>宏脉微信商城</li>
        </ul>
        <div class="lf-copyright">
          <div style="display:none">
            <img
              src="../assets/img/police.png"
              style="width: 17px;height: 19px;margin-right: 10px;"
            />
            <span class="lf-span" style="cursor: pointer;" @click="toPolice"
              >广公网安备 44011302001028号</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { createWWLoginPanel } from "@/utils/wecom.cjs.js"; // 企微的api，目前npm下载和cdn引入都会出现api不全的情况，只能通过将包下载到本地进行应用，后续企微如修复可以使用其他方式（2024.06.21）
import { getToken } from "@/api/index.js";
import { nextTick } from "process";
export default {
  data() {
    return {
      ruleForm: {
        account: "", //账号
        password: "", //密码
      },
      ruleAccount: false, //自定义正则账号
      rulePassword: false, //自定义正则密码
      fouceAccount: false, //聚焦账号
      foucePassword: false, //聚焦密码
      ruleTitle: "密码有误!",
      switchover: false, //切换登录方式,true扫码登录，false密码登录
      bgStatus: false, //切换背景色
      origin: "", //当前域
      appid: "",
      redirectUri: "",
      nowDate: dayjs().format("YYYY"),
    };
  },
  mounted() {
    this.origin = window.location.origin;
    // 生产环境  1.测试、2.正式
    if (process.env.NODE_ENV === "production") {
      if (
        location.hostname &&
        location.hostname == "wecom-callback.dev.hmsaas.cn"
      ) {
        // 2.新版智能专区会话存档 测试
        this.appid = "ww467a6c1f1323c56a";
        this.redirectUri =
          "https://wecom-callback.dev.hmsaas.cn/klb-service/api/qywechat/oAuth2Redirect";
      } else {
        // 2.正式
        this.appid = "wwd084d7152c3a1e1b";
        // this.redirectUri = 'http://wx.hmcsoft.com:8016/api/qywechat/oAuth2Redirect'
        this.redirectUri = "https://klb.hmsaas.cn/api/qywechat/oAuth2Redirect";
      }
      console.log("生产生产");
    } else {
      // 开发环境
      this.appid = "ww467a6c1f1323c56a";
      // this.redirectUri = 'http://hmmjh.natapp1.cc/api/qywechat/oAuth2Redirect'
      // this.redirectUri = 'http://baofengxue2022.natapp1.cc/api/qywechat/oAuth2Redirect'
      // this.redirectUri = 'http://baofengxue2024.natappvip.cc/api/qywechat/oAuth2Redirect'
      // this.redirectUri =
      //   "http://wecom.test.hmcsoft.net:8016/api/qywechat/oAuth2Redirect";
      this.redirectUri =
        "https://wecom-callback.dev.hmsaas.cn/klb-service/api/qywechat/oAuth2Redirect";
      console.log("开发开发");
    }
    this.bgStatus =
      window.localStorage.getItem("BGLOGIN") == "true" ? true : false;
  },
  methods: {
    // 切换登录背景主题
    clickGround(value) {
      this.bgStatus = value;
      window.localStorage.setItem("BGLOGIN", value);
    },
    // 切换
    clickTap() {
      // window.location.href =

      // 本地
      // "https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=ww467a6c1f1323c56a&redirect_uri=http://hmmjh.natapp1.cc/api/qywechat/oAuth2Redirect&usertype=member";
      // 测试
      // `https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=ww467a6c1f1323c56a&redirect_uri=http://wecom.test.hmcsoft.net:8016/api/qywechat/oAuth2Redirect&usertype=member`;
      // 正式
      // "https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=wwd084d7152c3a1e1b&redirect_uri=http://wx.hmcsoft.com:8016/api/qywechat/oAuth2Redirect&usertype=member";
      window.location.href = `https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=${this.appid}&redirect_uri=${this.redirectUri}&usertype=member`;
      // window.location.href =
      //   // 本地
      // "https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=ww467a6c1f1323c56a&redirect_uri=http://hmmjh.natapp1.cc/api/qywechat/oAuth2Redirect&usertype=member";
      // 测试
      // `https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=ww467a6c1f1323c56a&redirect_uri=http://wecom.test.hmcsoft.net:8016/api/qywechat/oAuth2Redirect&usertype=member`;

      // 正式
      // "https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=wwd084d7152c3a1e1b&redirect_uri=http://wx.hmcsoft.com:8016/api/qywechat/oAuth2Redirect&usertype=member";
      // this.switchover = !this.switchover;
    },
    //提交登录
    submitForm(ruleForm) {
      if (this.ruleForm.account === "" || this.ruleAccount) {
        this.blurAccount();
        return;
      } else if (this.ruleForm.password === "") {
        this.blurPassword();
        return;
      }
      // 请求接口
      if (this.ruleForm.password !== "123123") {
        this.rulePassword = true;
        this.ruleTitle = "密码有误!";
      } else {
        this.$message.success("登录成功");
      }
    },
    // 账号正则验证
    blurAccount() {
      this.fouceAccount = false;
      if (this.ruleForm.account === "" || this.ruleForm.account.length < 11) {
        return;
      }
      if (this.ruleForm.account !== "18888888888") {
        this.ruleAccount = true;
        this.ruleTitle = "账号手机未注册！";
      } else {
        this.ruleAccount = false;
      }
    },
    // 密码正则
    blurPassword() {
      if (this.ruleForm.password === "") {
        this.rulePassword = true;
        this.ruleTitle = "密码有误!";
      } else {
        this.rulePassword = false;
      }
    },
    // 账号密码聚焦
    focusAccount(keyValue) {
      if (keyValue == "账号") {
        this.ruleAccount = false;
        this.fouceAccount = true;
      } else {
        this.rulePassword = false;
        this.foucePassword = true;
      }
    },
    //粤ICP证  跳转
    toPolice() {
      // window.location.href = "https://beian.miit.gov.cn/#/Integrated/index"
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
  },
  computed: {
    ruleLogin() {
      let status = true;
      if (
        this.ruleForm.account.length == 11 &&
        this.ruleForm.account !== "" &&
        this.ruleForm.password !== ""
      ) {
        status = false;
      } else {
        status = true;
      }
      return status;
    },
  },
  created() {
    const that = this;

    console.log('测试域名------created',process.env);
    this.$nextTick(() => {
      /** 文档地址：https://developer.work.weixin.qq.com/document/path/98478 */
      const wwLogin = createWWLoginPanel({
        el: ".login-box", //登录组件挂载元素
        params: {
          /** 	ServiceApp：第三方应用登录 CorpApp：企业自建应用登录、服务商代开发应用登录*/
          login_type: "ServiceApp", //登录类型
          appid:process.env.VUE_APP_APPID,
          // appid: "wwc41afc80e94ecd9a", //登录类型为企业自建应用/服务商代开发应用时填企业 CorpID，第三方登录时填登录授权 SuiteID 宏脉软件(开发环境)
          // appid: "ww467a6c1f1323c56a", //登录类型为企业自建应用/服务商代开发应用时填企业 CorpID，第三方登录时填登录授权 SuiteID  宏脉技术
          // appid: "ww9d64a78f1253ffc2", //登录类型为企业自建应用/服务商代开发应用时填企业 CorpID，第三方登录时填登录授权 SuiteID 宏脉技术登录通用开发参数
          // appid: "wwd084d7152c3a1e1b", //登录类型为企业自建应用/服务商代开发应用时填企业 CorpID，第三方登录时填登录授权 SuiteID
          // appid: "ww986db9f53eb9e176", //登录类型为企业自建应用/服务商代开发应用时填企业 CorpID，第三方登录时填登录授权 SuiteID 宏脉信息   (测试环境)
          // appid: "ww9449f9b791d1878d", //登录类型为企业自建应用/服务商代开发应用时填企业 CorpID，第三方登录时填登录授权 SuiteID 宏脉智数  预发布
          // appid: "ww0a42b846d76a027f", //登录类型为企业自建应用/服务商代开发应用时填企业 CorpID，第三方登录时填登录授权 SuiteID 宏脉软件  生产
          // agentid: "1000290", //企业自建应用/服务商代开发应用 AgentID
          agentid: "1000266", //企业自建应用/服务商代开发应用 AgentID
          redirect_uri:process.env.VUE_APP_REDIRECT_URL,
          // redirect_uri: "https://wecom-callback.dev.hmsaas.cn", //登录成功重定向 url 无需进行 URLEncode 开发
          // redirect_uri: "https://mgr-callback.test.hmsaas.cn", //登录成功重定向 url 无需进行 URLEncode 测试
          // redirect_uri: "http://wecom-pre.hmsaas.cn", //登录成功重定向 url 无需进行 URLEncode 预发布
          // redirect_uri: process.env.NODE_ENV === "production"?"https://mgr-callback.test.hmsaas.cn":"https://mgr2-callback.test.hmsaas.cn", //登录成功重定向 url 无需进行 URLEncode
          state: "loginState", //登录 state 用于保持请求和回调的状态，授权请求后原样带回给企业。该参数可用于防止 CSRF 攻击（跨站请求伪造攻击），建议带上该参数，可设置为简单的随机数加 session 进行校验
          /** 	top：默认 top window 顶层页面跳转 callback：通过 onLoginSuccess 回调用户授权 code，开发者自行处理跳转 self 登录组件跳转*/
          redirect_type: "callback", //登录成功跳转类型
          /** 	middle：默认: 480x416px small：小尺寸: 320x380px*/
          panel_size: "small", //登录面板大小
          /** 语言类型 	zh：中文 	en：英文*/
          // lang：zh
        },
        /** 获取企业微信桌面端登录状态回调 */
        onCheckWeComLogin({ isWeComLogin }) {
          // 获取企业微信桌面端登录状态回调
          // 企业微信Web登录组件，默认会显示二维码登录，当满足以下条件时，会显示快速登录面板：
          // 用户的企业微信桌面端（Win & Mac）版本大于 3.1.23，运行并登录企业微信
          // 使用 @wecom/jssdk 初始化企业微信登录组件时，开发者网页域名需使用 HTTPS 协议
          // 在自建/代开发应用的登录场景中（login_type=CorpApp），当前企业微信桌面端登录用户，在所登录应用的可见范围内
          // 登录网页在桌面端系统浏览器中打开。如果需要在企业微信内置 Webview 进行登录，请使用OAuth授权登录
          console.log("企业微信桌面端登录状态", isWeComLogin);
        },
        /** 企业微信登录成功回调 需配置 redirect_type=callback*/
        onLoginSuccess({ code }) {
          window.location.href = `${process.env.VUE_APP_REDIRECT_URL}?code=${code}`
          // Auth Code
          /** 成功后使用code作为参数，直接请求后端接口 */
          // window.location.href = `https://wecom-callback.dev.hmsaas.cn/adminApi/api/qywechat/loginUser?code=${code}`;//开发
          // window.location.href = `http://wecom-pre.hmsaas.cn/adminApi/api/qywechat/loginUser?code=${code}`; //预发布
          // window.location.href = `https://wecom.hmsaas.cn/klb-service/api/qywechat/loginUser?code=${code}`; //生产
          // window.location.href = `https://mgr-callback.test.hmsaas.cn/klb-service/api/qywechat/loginUser?code=${code}`; //测试
          // window.location.href =  process.env.NODE_ENV ==="production"? `https://mgr-callback.test.hmsaas.cn/klb-service/api/qywechat/loginUser?code=${code}`:`https://mgr2-callback.test.hmsaas.cn/klb-service/api/qywechat/loginUser?code=${code}`;
        },
        /** 企业微信登录错误回调  */
        onLoginFail(err) {
          // -31020	redirect_uri 与配置的登录授权调域名不一致
          // -31027	appid 参数错误
          // -31028	agentid 参数错误
          // -31033	校验请求来源错误
          // -31034	该企业不是服务商
          // -31035	redirect_uri 不能为空
          // -31037	appid 非登录授权应用
          // -31039	redirect_uri 与配置的可信域名不一致
          // -31040	login_type 参数错误
          console.log("失败了？", err);
        },
        /** 打开企业微信客户端成功回调 */
        onOpenInWecom(val) {},
      });
    });
  },
};
</script>
<style lang="scss">
.login-main {
  position: relative;
  width: 100%;
  background-color: #f7f9ff;

  .login-header {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 70px;
    font-weight: 600;
    color: #4b8adc;
    background: #ffffff;
    box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07),
      0px 30.1471px 24.1177px rgba(0, 0, 0, 0.0456112),
      0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
      0px 4.5288px 3.62304px rgba(0, 0, 0, 0.0243888);

    .lh-left {
      margin-left: 31px;
      display: flex;
      align-items: center;
      font-size: 23px;

      img {
        vertical-align: middle;
        width: 41px;
        height: 22px;
        margin-right: 4px;
      }

      &::after {
        content: "";
        position: relative;
        top: 0px;
        right: -20px;
        width: 0px;
        height: 28px;
        border: 1px solid #4b8adc;
      }
    }

    .lh-right {
      display: flex;
      align-items: center;
      margin-left: 40px;
      font-size: 23px;

      .lhr-centen {
        display: flex;
        margin: 2px 0 0 16px;
        font-size: 12px;
        border: 1px solid #1f74ff;
        border-radius: 4px;
        transform: scale(0.9);

        p {
          margin: 0px;
          height: 18px;
          background-color: #1f74ff;
        }

        img {
          width: 22px;
          height: 16px;
        }

        span {
          margin: 0 4px;
        }
      }
    }

    .lh-cut {
      position: absolute;
      right: 19.53%;
      display: flex;
      align-items: center;

      i {
        display: block;
        width: 15px;
        height: 15px;
        background: #d9e7ff;
        border-radius: 50%;
        margin-right: 10px;
        cursor: pointer;
      }

      .lh-cut-active {
        padding: 2px;
        border: 1px solid #4b8adc;
      }
    }
  }

  .login-centen {
    position: relative;
    width: 100%;
    margin-top: 130px;
    height: calc(100vh - 200px);
    min-height: 443px;
    background: url(../assets/img/group_bai.png);
    background-size: 100%;
    background-size: cover;

    .login-left {
      margin-left: 160px;

      img {
        margin-top: -62px;
        width: 450px;
        height: 317px;
      }
    }

    .login-box {
      position: absolute;
      // left: 64.4%;
      right: 10%;
      top: 60px;
      // bottom: 29.67%;
      // padding: 0px 40px;
      // width: 250px;
      // height: 400px;
      // background: #ffffff;
      // box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07),
      //   0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198),
      //   0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275),
      //   0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
      //   0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725),
      //   0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
      // border-radius: 10px;

      .lb-weicome {
        margin-top: 30px;
        text-align: center;
        // margin-top: 40px;
        font-weight: 300;
        font-size: 24px;
        letter-spacing: 0.364px;
        color: #404040;
      }

      .lb-title {
        margin-top: 12px;
        text-align: center;
        font-weight: 600;
        font-size: 30px;
        letter-spacing: 0.364px;
        color: #404040;
      }

      .lb-form {
        margin-top: 32px;
        color: #6a717f;

        .password {
          margin-top: 26px;
        }

        .el-form-item {
          margin-bottom: 0 !important;
        }

        .el-input__inner {
          background: #ffffff;
          border: 1px solid #e5e7eb;
          box-sizing: border-box;
          box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.05);
          border-radius: 6px;
        }

        .el-input__inner:focus {
          border-color: #409eff !important;
          outline: 0;
        }

        .el-form-item__label {
          line-height: 0px !important;
          margin-bottom: 16px;
        }

        .el-button {
          margin-top: 24px;
          width: 100%;
          background: linear-gradient(90deg, #5b98f4 -1.69%, #00d0dd 100%);
          border-color: #23bae6;
          border-radius: 6px;
        }

        .rule-login .el-button {
          border-color: #f3f4f6;
          background: #f3f4f6;
          color: #9ca3af;
        }

        .rule-account,
        .rule-password {
          .el-form-item__label {
            color: #f43f5e !important;
          }

          .el-input__inner {
            color: #f43f5e !important;
          }

          .el-input__inner {
            border-color: #e53359 !important;
            box-shadow: 0px 2px 3px #f1c3ca;
          }
        }

        .fouce-input .el-form-item__label {
          color: #409eff;
        }
      }

      .rule-message {
        margin: 16px 0 22px;
        width: 100%;
        height: 36px;
        background: #ffe4e6;
        border-radius: 6px;
        color: rgba(246, 63, 94, 0.92);

        i {
          margin: -4px 10px 0 15px;
        }

        span {
          color: #f43f5e;
          margin-top: -3px;
        }
      }

      .lb-agreement {
        margin-top: 13px;
        font-size: 14px;

        span {
          color: #8fb9ff;
          cursor: pointer;
        }
      }

      .lb-footer {
        position: absolute;
        left: 111px;
        bottom: 21px;
        width: 140px;
        height: 14px;
        font-size: 14px;

        span {
          color: #8fb9ff;
          cursor: pointer;
        }
      }

      .el-input .el-input__clear {
        font-size: 20px;
      }

      .lb-scan-code {
        position: absolute;
        top: 30px;
        right: 65px;
        padding: 4px 10px;
        font-size: 12px;
        color: #1f74ff;
        background-color: #e2edff;
        border: 1px solid #1f74ff;
        z-index: 12;
        border-radius: 4px;

        &::after {
          content: "";
          position: absolute;
          top: 7px;
          right: -5px;
          width: 0;
          height: 0;
          border-top: 5px solid transparent;
          border-left: 5px solid #1f74ff;
          border-bottom: 5px solid transparent;
        }

        &::before {
          content: "";
          position: absolute;
          top: 8px;
          right: -4px;
          width: 0;
          height: 0;
          border-top: 4px solid transparent;
          border-left: 4px solid #e2edff;
          border-bottom: 4px solid transparent;
          z-index: 100;
        }
      }

      .lb-code {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 0;
        height: 0;
        cursor: pointer;
        border-top: 88px solid #e2edff;
        border-left: 88px solid transparent;
        z-index: 10;

        img {
          width: 66px;
          height: 66px;
          position: absolute;
          top: -86px;
          right: 0px;
        }

        .lb-img {
          width: 58px;
          height: 58px;
          top: -80px;
          right: 8px;
        }

        &::after {
          content: "";
          position: absolute;
          top: -87px;
          right: 0px;
          width: 0;
          height: 0;
          border-bottom: 88px solid #ffffff;
          border-right: 88px solid transparent;
          z-index: 11;
        }
      }
    }

    .login-code {
      .lc-title {
        margin: 26px auto 20px;
        width: 135px;
        height: auto;

        img {
          vertical-align: middle;
          width: 21px;
          height: 18px;
        }

        span {
          margin-left: 15px;
          color: #1f74ff;
        }
      }

      .lc-code {
        // margin: 0 auto;
        // width: 213.66px;
        // height: 213.66px;
        // background: #eaeaea;
        margin: 30px auto 0px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 150px;
        cursor: pointer;

        &:hover {
          color: #1f74ff;
        }

        img {
          margin-left: 10px;
        }
      }

      .lc-footer {
        margin-top: 30px;
        font-size: 12px;
        color: #8a8a8a;
        text-align: center;
      }
    }
  }

  .login-footer {
    position: absolute;
    left: calc((100% - 1461px) / 2);
    bottom: 15px;
    width: 1461px;
    height: auto;
    font-size: 13px;
    color: #4b8adc;

    .lf-top {
      display: flex;
      position: relative;
      border-bottom: 1px solid rgba(75, 138, 220, 0.5);

      ul {
        display: flex;
        padding-left: 0;
        margin: 14px 0;

        li {
          margin-right: 42px;
          list-style: none;
          cursor: pointer;

          &:hover {
            color: #1f74ff;
            text-decoration: underline;
          }
        }
      }

      .lf-copyright {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        div {
          margin-top: 12px;
        }

        .lf-span {
          color: #4b8adc;
          text-decoration: unset;
        }
      }
    }

    .lf-top:nth-child(2) {
      border-bottom: none;
    }
  }

  @media screen and (max-width: 1600px) {
    .login-footer {
      width: 1196px !important;
      left: calc((100% - 1196px) / 2) !important;
    }
  }

  @media screen and (max-width: 1200px) {
    .login-footer {
      width: 1000px !important;
      left: calc((100% - 1000px) / 2) !important;
    }
  }
}

.login-bg {
  background-color: #062247;

  .login-header {
    background-color: #042d64 !important;
    color: #b4d0ff !important;

    .lh-left::after {
      border: 1px solid #b4d0ff !important;
    }
  }

  .lhr-centen {
    border: 1px solid #b4d0ff !important;
    color: #b4d0ff !important;
  }

  .login-footer {
    color: #b4d0ff !important;

    .lf-top {
      li {
        &:hover {
          color: #ffffff !important;
        }
      }
    }

    .lf-copyright {
      .lf-span {
        color: #b4d0ff !important;
        text-decoration: underline;
      }
    }
  }

  .lf-top {
    // border-bottom: 1px solid#CFD0D1 !important;
    &:nth-child(2) {
      border-bottom: 0px !important;
    }
  }
}
</style>
